import { render, staticRenderFns } from "./BOverlay.component.vue?vue&type=template&id=420fe81c&scoped=true"
import script from "./BOverlay.component.vue?vue&type=script&lang=js"
export * from "./BOverlay.component.vue?vue&type=script&lang=js"
import style0 from "./BOverlay.component.vue?vue&type=style&index=0&id=420fe81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420fe81c",
  null
  
)

export default component.exports